module.exports = __webpack_public_path__ + "static/img/partner_XIX.432c932.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_XIX.png
// module id = CH/N
// module chunks = 9